import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@constants/routes';

/**
 * Routes were Indonesian before v0.3.2 (/surat-jalan, /tabung, /op/kirim, ...) and operations mode lived under
 * /op in v0.3. Printed delivery-note QR codes, bookmarks and shared links still point there, so they
 * redirect to the current routes. Order matters: the first match wins.
 */
const LEGACY: [RegExp, string][] = [
  [/^\/surat-jalan\/([^/]+)\/cetak(?=\/|$)/, '/shipments/$1/print'],
  [/^\/surat-jalan(?=\/|$)/, '/shipments'],
  [/^\/tabung(?=\/|$)/, '/cylinders'],
  [/^\/lokasi(?=\/|$)/, '/locations'],
  [/^\/gateway(?=\/|$)/, '/gateways'],
  [/^\/peringatan(?=\/|$)/, '/alerts'],
  [/^\/pembaruan(?=\/|$)/, '/updates'],
  [/^\/pengguna(?=\/|$)/, '/users'],
  [/^\/akun(?=\/|$)/, '/account'],
  [/^\/op\/(send|kirim)(?=\/|$)/, '/operations/dispatch'],
  [/^\/op\/(check|cek)(?=\/|$)/, '/operations/lookup'],
  [/^\/op\/terima(?=\/|$)/, '/operations/receive'],
  [/^\/op\/daftar(?=\/|$)/, '/operations/register'],
  [/^\/op\/lokasi(?=\/|$)/, '/operations/location'],
  [/^\/op(?=\/|$)/, '/operations'],
];

/** The English route for an old path, or null when the path is not a legacy route. */
export function legacyTarget(pathname: string): string | null {
  for (const [from, to] of LEGACY) if (from.test(pathname)) return pathname.replace(from, to);
  return null;
}

/** Rendered for legacy route prefixes: keeps the rest of the path, the query and the hash. */
export function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${legacyTarget(pathname) ?? ROUTES.home}${search}${hash}`} replace />;
}

/** Top-level route patterns that belong to the old URLs. */
export const LEGACY_PATTERNS = ['/surat-jalan/*', '/tabung/*', '/lokasi/*', '/gateway/*', '/peringatan/*', '/pembaruan/*', '/pengguna/*', '/akun/*', '/op/*'];
